module.exports = __webpack_public_path__ + "images/howitworks-step1.b5c4caa5d7c7006755807554c984a910.svg";